<div class="container">
  <div class="col-sm-12 col-xl-6 media">
    <span class="title">{{ "DOWNLOAD_APP" | translate }}</span>
    <span class="note">{{ "DOWNLOAD_APP_NOTE" | translate }}</span>
    <div class="app-links d-flex">
      <a href="https://apps.apple.com/eg/app/hidaya-libya/id6742405750?l=ar" target="_blank">
        <img src="../../../assets/images/app-store.png" alt="">
      </a>

      <a href="https://play.google.com/store/apps/details?id=com.hidayalibya&hl=en" target="_blank">
        <img src="../../../assets/images/google-play.png" alt="">
      </a>
    </div>
  </div>
</div>